const NESTED_SCOPES = ['third-party-managements']

const kebabToCamel = (value) =>
  value?.replace(/-([a-z])/g, (_, char) => char.toUpperCase())

const resolveListPath = (routePath, routes, nestedScopes = NESTED_SCOPES) => {
  const segments = routePath.split('/')
  const scope = segments[1]

  if (!nestedScopes.includes(scope)) {
    return `/${scope}/`
  }

  const subRoute = segments[2]
  if (!subRoute) return `/${scope}/`

  const scopeKey = kebabToCamel(scope)
  const subRouteKey = kebabToCamel(subRoute)
  const subRouteValue = routes?.[scopeKey]?.[subRouteKey]
  const hasOwnListing = typeof subRouteValue === 'object'

  return `/${scope}/${subRoute}${hasOwnListing ? '/' : ''}`
}

export { NESTED_SCOPES }
export default resolveListPath
